module.exports = __webpack_public_path__ + "static/media/menu-scheduling.4060fc9d.svg";